export const ADDRESS_NAME_MAX_LENGTH = 35;
//# sourceMappingURL=addressNameLength.js.map